export const TRADE_REQUEST_TABS = ['received', 'sent'];
